import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { FeatureFlags } from "./featureFlags";
import { Library, Application } from '../../machinelogic/types';
import { PythonApplicationCard } from './PythonApplicationCard';
import { MachinelogicApplicationCard } from './MachinelogicApplicationCard';
import { ApplicationTypes } from '../../machinelogic/constants/ApplicationTypes';
import './styles/CustomAppsSection.css';

interface CustomAppSectionProps {
  library: Library;
  openMachineLogicAppEditor: () => void;
  openPythonAppEditor: () => void;
}
/**
 * This is a section for custom apps
 * @param param
 * @param param.library - the library
 * @param param.openMachineLogicAppEditor - callback to open machine logic app editor
 * @param param.openPythonAppEditor - callback to open python app editor
 * @returns - a section for custom apps
 */
export const CustomAppsSection: FC<CustomAppSectionProps> = observer(({library, openMachineLogicAppEditor, openPythonAppEditor}) => {
  const currentApplication = library.currentApplication;
  const machineLogicAppList = library.getMachineLogicAppList();
  const pythonAppList = library.getPythonAppList();
  const hasMachineLogicApps = machineLogicAppList.length > 0;
  const hasPythonApps = pythonAppList.length > 0;

  const openMLAppEditorHandler = () => {
    let appToOpen;

    // if we don't have any machine logic apps, create a new one
    if (!hasMachineLogicApps) {
      appToOpen = library.newApplication(ApplicationTypes.MachineLogic);
    }
    // if the current application is a machine logic app, open it
    else if (currentApplication && currentApplication.getType() === ApplicationTypes.MachineLogic) {
      appToOpen = currentApplication;
    }
    // we have machinelogic apps but no current machine logic app
    else {
      appToOpen = machineLogicAppList[0];
    }

    library.selectApplication(appToOpen);
    openMachineLogicAppEditor();
  };

  const openPythonAppEditorHandler = () => {
    let appToOpen;

    // if we don't have any python apps, create a new one
    if (!hasPythonApps) {
      appToOpen = library.newApplication(ApplicationTypes.Python);
    }
    // if the current application is python app, open it
    else if (currentApplication && currentApplication.getType() === ApplicationTypes.Python) {
      appToOpen = currentApplication;
    }
    // we have python apps but no current python app
    else {
      appToOpen = pythonAppList[0];
    }

    library.selectApplication(appToOpen);
    openPythonAppEditor();
  };

  return (
    <div className='ml_application_landing_page_custom_app_list'>
      <MachinelogicApplicationCard
        openMachineLogicAppEditor={openMLAppEditorHandler}
        hasMachinelogicApp={hasMachineLogicApps}
      />
      {FeatureFlags.PythonApplications &&
          <PythonApplicationCard
            openPythonAppEditor={openPythonAppEditorHandler}
            hasPythonApp={hasPythonApps}
          />
      }
    </div>
  );
});
